<template>
  <div class="toolbar flex align-center">

    <div class="box grow">
      <button @click="toggleSidebar"
              v-if="menuBurger !== 'right'"
              class="toggle-sidebar card-base card-shadow--small">
        <img src="@/assets/images/muen.png">
      </button>
    </div>
    <div class="pl-10">
      <!-- 切换翻译下拉菜单 -->
      <el-dropdown trigger="click"
                   @command="onCommandLang">
        <span class="el-dropdown-link">
          <b>{{langName}}</b>&nbsp;
          <i class="el-icon-arrow-down"></i>
        </span>
        <el-dropdown-menu slot="dropdown"
                          style="padding:0;">
          <el-dropdown-item v-for="(item, index) in langArr"
                            :key="index"
                            :command='item'>{{item.name}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- 登录后在此显示用户名 -->
      <!-- <b class="username">{{$t('header.welcome')}}&nbsp;{{username}}&nbsp;&nbsp;{{'<' + accountNumber + '>'}}</b> -->
      <b class="username">{{$t('header.welcome')}}&nbsp;{{username}}</b>
    </div>

  </div>
</template>

<script>
// import Vue from 'vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Toolbar',
  props: ['menuBurger'],
  data () {
    return {
      popoverWidth: 300,
      fullscreen: false,
      langName: 'en',
      langArr: [
        // { abbreviation: 'us', name: 'ENGLISH' },
        { abbreviation: 'cn', name: '简体中文' },
        { abbreviation: 'hk', name: '繁體中文' },
        { abbreviation: 'en', name: 'English' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectLang', 'getUser', 'getAccountInfo', 'getClientProfile']),
    profile () {
      return this.$getProfile ? this.$getProfile() : null
    },
    accountNumber () {
      return this.getAccountInfo ? this.getAccountInfo.accountNumber : ''
    },
    username () {
      if (this.getClientProfile && this.getClientProfile.userInfo && this.getClientProfile && this.getClientProfile.userInfo.type === 'COMPANY') {
        return this.getClientProfile.userInfo.name
      } else {
        let lastName = this.getClientProfile && this.getClientProfile.userInfo && this.getClientProfile.userInfo.lastName ? this.getClientProfile.userInfo.lastName : ''
        let firstName = this.getClientProfile && this.getClientProfile.userInfo && this.getClientProfile.userInfo.firstName ? this.getClientProfile.userInfo.firstName : ''
        return lastName + ' ' + firstName
      }
    }
  },
  watch: {
    selectLang: {
      handler (val) {
        if (val) {
          // console.log(val)
          this.changeLangName(val)
        }
      }
    }
  },
  created () {
    let curLang = sessionStorage.getItem('language') ? sessionStorage.getItem('language') : 'cn'
    this.changeLangName(curLang)
  },
  methods: {
    getLanguage () {
      let languageM = this.Util.getCookie('language') ? this.Util.getCookie('language') : 'cn'
      let curLang = ''
      switch (languageM) {
        case 'en':
          curLang = 'en'
          break
        case 'zh-hant':
          curLang = 'hk'
          break
        case 'zh-hans':
          curLang = 'cn'
          break
        default:
          curLang = 'cn'
          break
      }
      return curLang
    },
    changeLangName (curLang) {
      for (let value of this.langArr) {
        if (curLang === value['abbreviation']) {
          console.log(curLang)
          this.langName = value['name']
          break
        }
      }
    },
    onCommandLang (obj) {
      // Vue.setLanguage(obj.abbreviation)
      sessionStorage.setItem('language', obj.abbreviation)
      this.$i18n.locale = sessionStorage.getItem('language')
      this.$store.commit('setCurLang', obj.abbreviation)
      sessionStorage.setItem('isChange', 'yes')
      location.reload()
    },
    toggleSidebar () {
      this.$emit('toggle-sidebar')
    },
    resizePopoverWidth () {
      if (window.innerWidth <= 768) {
        this.popoverWidth = 250
      } else {
        this.popoverWidth = 300
      }
    }
    // getUserInfo (clientProfile) {
    //   if (clientProfile) {
    //     this.accountNumber = clientProfile.accountNumber
    //     this.username = clientProfile.lastName + ' ' + clientProfile.userInfo.firstName
    //   }
    // }
  },
  mounted () {
    this.fullscreen = this.$fullscreen.getState()
    this.resizePopoverWidth()
    window.addEventListener('resize', this.resizePopoverWidth)
    // this.getUserInfo()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizePopoverWidth)
  }
}
</script>

<style lang="scss">
.toolbar {
  width: 100%;
  height: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  .username {
    margin-left: 20px;
    font-size: 14px;
  }
  .el-dropdown {
    color: #192b57;
  }
  .toggle-sidebar {
    border: 1px solid transparent;
    height: 32px;
    min-height: 32px;
    line-height: 32px;
    width: 32px;
    min-width: 32px;
    max-width: 32px;
    box-sizing: border-box;
    text-align: center;
    margin: 0;
    outline: none;
    margin-right: 5px;
    font-size: 24px;
    padding: 0;
    cursor: pointer;
    display: inline-block;
    background: white;
    display: none;
    opacity: 0;
    transition: all 0.5s;

    &__right {
      margin-right: 0px;
      margin-left: 5px;
    }
  }
}

@media (max-width: 650px) {
  .toolbar {
    .username {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  .toolbar {
    padding: 0 10px;

    .toggle-sidebar {
      display: block;
      opacity: 1;
    }
  }
}
</style>
